<p-dialog id="showdoctree"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          appendTo="body"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()">
  <ng-template pTemplate="content">
    <div class="fluid">
      <p-tree [value]="docTreeNodes"
              (onNodeExpand)="nodeExpand($event)"
              (onNodeSelect)="nodeSelect($event)"
              [(selection)]="selectedNode"
              [loading]="loading"
              scrollHeight="50%"
              key="DOCID"
              filter="true"
              filterPlaceholder="Поиск по имени документа"
              selectionMode="single"
              [disabled]="disabled"></p-tree>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="Открыть" icon="pi pi-file" (click)="onGoToDocument('go')" [disabled]="!_outputDoc" style="mr-4"></p-button>
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm('ok')"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
